import { useStore } from "@tmsw/powerups.store";

export default function useSkipChapter() {
  const { showSkip, skipTarget } = useStore(state => ({ showSkip: state.showSkip, skipTarget: state.skipTarget }));
  return !showSkip && skipTarget ? skipTarget : null;
}